<template>
	<v-layout
		row wrap white id="features"
		class="section-features"
	>
		<v-flex xs12 md7 secondary--text class="section-features-text">
			<h3 class="section-features-title">¿Por qué debes aprovechar</h3>
			<h3 class="section-features-title section-features-title-big">Esta Oportunidad?</h3>
			<v-layout row wrap secondary--text>
				<v-flex xs12 mb-2>
					<img src="/static/images/icons/icon-6.svg" height="42">
					<p class="section-features-feature">CONTRIBUYES AL AISLAMIENTO OBLIGATORIO</p>
				</v-flex>
				<v-flex xs12 mb-2>
					<img src="/static/images/icons/icon-1-CM.svg" height="42">
					<p class="section-features-feature">TU TIENDA DISPONIBLE 24/7</p>
				</v-flex>
				<v-flex xs12>
					<p class="section-features-number">95%</p>
					<p class="section-features-feature">DE TUS CLIENTES TIENE UN SMARTPHONE</p>
				</v-flex>
				<v-flex xs12>
					<p class="section-features-number">80%</p>
					<p class="section-features-feature">DE TUS CLIENTES USAN APLICATIVOS PARA COMPRAR</p>
				</v-flex>
				<v-flex xs12 class="container-desktop">
					<button class="section-features-btn py-3" @click="$emit('open-modal-btn')">
						<p class="mb-0">DESEO CONOCER LA PROMOCIÓN DE LANZAMIENTO</p>
					</button>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 md4 class="section-features-image">
			<img src="/static/images/sections/feature-1.png" height="590" alt="app mi bodega">
		</v-flex>
		<v-flex xs12 text-xs-center class="container-mobile">
			<button class="section-features-btn pa-2" @click="$emit('open-modal-btn')">
				<p class="mb-0">DESEO CONOCER LA PROMOCIÓN <br/> DE LANZAMIENTO</p>
			</button>
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		name: 'section-features',
		props: {
			link: [String],
		},
	};
</script>

<style lang="scss" scoped>
	.section-features {
		padding: 48px 5%;

		@media (min-width: 360px) {
			padding: 48px 10%;
		}

		@media (min-width: 1024px) {
			padding: 127px 19%;
		}

		&-title {
			font-size: size(medium20);
			font-weight: weight(w900);
			line-height: normal;
			text-transform: uppercase;

			@media (min-width: 1024px) {
				font-size: size(large30);
			}

			&-big {
				font-size: size(large25);
				margin-bottom: 48px;

				@media (min-width: 1024px) {
					font-size: size(large39);
				}
			}
		}

		&-feature {
			font-size: size(medium16);
			font-weight: weight(w700);
		}

		&-number {
			color: color(primary-cs);
			font-size: size(large30);
			font-weight: weight(w900);
			margin-top: 15px;
			margin-bottom: 0px;
		}

		&-image {
			padding-top: 30px;
			text-align: center;

			@media (min-width: 1024px) {
				padding-top: 0px;
				text-align: right;
			}
		}

		&-text {
			text-align: center;

			@media (min-width: 1024px) {
				text-align: left;
			}
		}

		&-btn {
			background-color: color(primary-cs) !important;
			border-radius: 8px;
			box-shadow: none;
			color: color(white) !important;
			display: inline-block;
			height: auto !important;
			margin: 30px 0 0 0;
			text-align: center;
			text-decoration: none;
			width: 80%;
		}

		.container-mobile {
			@media (min-width: 1024px) {
				display: none;
			}
		}

		.container-desktop {
			display: none;
			@media (min-width: 1024px) {
				display: block;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-features.vue